import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	RestaurantFullInfoContext,
	IRestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const Tips3Field: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	if (restaurantForFullInfo?.defaultTips[3]) {
		return (
			<FullInfoField
				label={restaurantForFullInfo.defaultTips[3].isDefault ? 'tips3DefaultLabel' : 'tips3Label'}
				value={restaurantForFullInfo.defaultTips[3].value}
			/>
		);
	}
	return <FullInfoField label="tips3Label" value={null} />;
};

export default Tips3Field;
